import React, { useEffect, useState } from 'react';
import { ActivityTabs, RootContainer } from '../../orders/Orders';
import styled from 'styled-components';
import { getActiveTabId, handleChangeTab } from '../../../utils/helper';
import ImagesGallery from '../../ImagesGallery/ImagesGallery';
import StyledSearchInput from '../../../app/components/styledComponents/StyledSearchInput';
import theme from '../../../utils/themes';
import StyledButton from '../../../app/components/styledComponents/StyledButton';
import {
  useGetImageCategoriesMutation,
  useGetImageTagsMutation,
  useUpdateImageCategoriesInBulkMutation,
} from '../../vendors/vendorsApiSlice';
import StyledText from '../../../app/components/styledComponents/StyledText';
import NewCloseIcon from '../../../app/components/svgIcons/NewCloseIcon';
import FilterHamburgerIcon from '../../../app/components/svgIcons/FilterHamburgerIcon';
import CustomDropdown from '../../../app/components/dropdown/CustomDropDown';
import {
  ButtonGroup,
  ButtonToolbar,
  Col,
  Container,
  Dropdown,
  Row,
} from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import useDebounce from '../../../hooks/useDebounce';
import BottomArrow from '../../../app/components/svgIcons/BottomArrow';
import { CustomDropdownStyle } from '../../../app/components/styledComponents/StyledCustomDropdown';
import StyledCheckbox from '../../../app/components/checkbox/StyledCheckbox';
import {
  CustomDropDownItem,
  CustomDropDownMenu,
  CustomDropDownToggle,
} from '../../products/ProductsHeader';

const StyledSpan = styled.span`
  border-radius: 5px;
  border: 1px solid #e0e0e0;
  user-select: none;
  cursor: pointer;
  padding: 8px 12px !important;
  svg {
    color: rgb(38, 7, 53) !important;
    height: 20px;
    width: 20px;
  }
`;

const StyledHeaderTag = styled.span`
  padding: 4px 12px 4px 12px;
  color: ${({ theme, active }) => (active ? theme.white : theme.bodyMedium)};
  font-family: ${(theme) => theme.fontFamily};
  border: 1px solid
    ${({ theme, active }) => (active ? 'transparent' : theme.dark40)};
  background-color: ${({ theme, active }) =>
    active ? theme.badgeText : theme.white};
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;

  p {
    margin: 0;
  }
`;

const staticFiltersList = [
  {
    id: 53,
    label: 'White Background',
  },
  {
    id: 10,
    label: 'Hero',
  },
  {
    id: 23,
    label: 'Horizontal Tile',
  },
  // {
  //   id: 79,
  //   label: 'Occassion',
  // },
];

const FilterTabOrderList = [
  'Flower Type',
  'Background',
  'Occasion',
  'Location',
  'Scene',
  'Items',
  'Type',
  'Style',
  'Size',
];

const [STATICTAGS, IMAGETAGS, FAVORITE, TYPE , CATEGORY] = [
  'staticTags',
  'imageTags',
  'favorite',
  'type',
  'category'
];

const Gallery = ({
  comingFrom,
  selectedImage,
  accessingVia,
  selectMulti = false,
}) => {
  const [showQuickFilters, setShowQuickFilters] = useState(false);
  const [getImageTags] = useGetImageTagsMutation();
  const location = useLocation();
  const ACCESSEDVIAOMAGEGALLERY =
    location?.pathname === '/admin/images-gallery';
  const [imageTags, setImageTags] = useState([]);
  const [tagList, setTagList] = useState([]);
  const [selectedImagesArray, setSelectedImagesArray] = useState([]);
  const [search, setSearch] = useState('');
  const [filter, setFilter] = useState({
    imageTags: [],
    staticTags: [],
    favorite: false,
    type: null,
    category : 80
  });
  const [tabs, setTabs] = useState([
    { name: 'Your Images', id: 1, active: true },
    { name: 'Product Images', id: 79, active: false },
    { name: 'Site Media', id: 2, active: false },
  ]);
  const [selectedTab, setSelectedTab] = useState(0);
  const [showOccasionTags, setShowOccasionTags] = useState(false);
  const [showOrientationTags, setShowOrientationTags] = useState(false);
  const [showHolidayTags, setShowHolidayTags] = useState(false);
  const [selectedTags, setSelectedTags] = useState(filter?.imageTags);
  const [filterShow, setFilterShow] = useState(false);
  const [selectImages, setSelectedImages] = useState([]);
  const [getImageCategories] = useGetImageCategoriesMutation();
  const [imageCategories, setImageCategories] = useState([]);
  const [updateImageCategory] = useUpdateImageCategoriesInBulkMutation();
  const [selectedCategory, setSelectedCategory] = useState(null);

  useEffect(() => {
    const fetchCategories = async () => {
      const cat = await getImageCategories();
      setImageCategories(cat?.data?.objectData);
    };
    fetchCategories();
  }, []);

  const handleQuickFilterTagChange = (item, e) => {
    if (e.target.checked) {
      const payload = [...selectedTags, item];
      setSelectedTags(payload);
    } else {
      const payload = selectedTags?.filter((_item) => _item.id !== item.id);
      setSelectedTags(payload);
    }
  };

  const searchQuery = useDebounce(search, 600);

  const fetchTags = async () => {
    try {
      const { data } = await getImageTags({
        page: 0,
        size: 1000,
      });
      const options = await data?.options?.map((option) => ({
        ...option,
        value: option.title,
        label: option.title,
      }));
      setImageTags(options);

      const tagsList = options
        ?.filter(
          (option) => !option.parentCategory && option.childTags?.length > 0,
        )
        .map((option) => ({
          ...option,
          childTags: option.childTags.map((childTag) => ({
            ...childTag,
            value: childTag.name,
            label: childTag.name,
          })),
        }));

      setTagList(tagsList);
    } catch (error) {}
  };

  const onChangeTabs = (tab) => {
    setTabs(handleChangeTab(tabs, tab));
  };

  const selectImage = (img) => {
    if (selectMulti) {
      setSelectedImagesArray([...img]);
      selectedImage(img);
    } else {
      selectedImage(img);
    }
  };

  const handleFiltersChange = (key, val) => {
    setFilter((prevState) => {
      const nextState = structuredClone(prevState);

      switch (key) {
        // case SEARCH:
        //   nextState[key] = val;
        //   return nextState;
        case FAVORITE:
          nextState[key] = !nextState.favorite;
          return nextState;
        case TYPE:
          nextState[key] = val;
          return nextState;
        case IMAGETAGS:
          nextState[key] = val;
          return nextState;
        case STATICTAGS:
          if (nextState[key].includes(val)) {
            nextState[key] = nextState[key].filter(
              (tagName) => tagName !== val,
            );
          } else {
            nextState[key] = [...nextState[key], val];
          }
          return nextState;
          case CATEGORY :
            nextState[key] = val;
            return nextState;
        default:
          return nextState;
      }
    });
  };

  const resetFilters = () => {
    setFilter({
      imageTags: [],
      staticTags: [],
      favorite: false,
      type: null,
    });
    setSearch('');
  };

  useEffect(() => {
    resetFilters();
  }, [location]);

  useEffect(() => {
    fetchTags();
  }, []);

  const matchingTagsCount = (tags) => {
    return (
      tags?.filter((tag) =>
        selectedTags?.some((selected) => selected.id === tag.id),
      )?.length || 0
    );
  };

  return (
    <RootContainer className={accessingVia === 'editTemplate' ? 'p-0' : ''}>
      {selectImages?.length > 0 &&
        process.env.REACT_APP_GALLERY_FILTER_LAYOUT_ENABLED === 'true' && (
          <div className="py-3 px-2">
            <Dropdown as={ButtonGroup}>
              <CustomDropDownToggle
                onClick={() => {
                  if(selectedTab === 79){
                    setSelectedCategory({
                      id : 80,
                      name : 'Image'
                    });
                  }
                  else {
                    setSelectedCategory({
                      id : 81,
                      name : 'Product Image'
                    });
                  }
                }}
                id="dropdown-basic"
              >
                {selectedTab === 79
                  ? 'Mark as Your Image'
                  : selectedTab === 1 || selectedTab === 0
                  ? 'Mark as Product Image'
                  : ''}
              </CustomDropDownToggle>
            </Dropdown>
          </div>
        )}

      <style>
        {`
            .dropdown-toggle::after {
              display: none !important;
            }
            `}
      </style>
      <Container fluid>
        <HeaderContainer
          className={`${ACCESSEDVIAOMAGEGALLERY ? 'p-2' : ''} d-flex flex-row ${
            location.pathname === '/admin/images-gallery'
              ? 'justify-content-end'
              : 'justify-content-between'
          }`}
        >
          {!ACCESSEDVIAOMAGEGALLERY && (
            <HeaderItem
              className={accessingVia === 'editTemplate' ? 'edit-temp' : ''}
            >
              {tabs.map((category) => (
                <span
                  key={category.id}
                  className={
                    category.id === getActiveTabId(tabs) ? 'active' : ''
                  }
                  onClick={() => {
                    setSelectedImages([]);
                    setShowQuickFilters(false);
                    setSelectedTab(category.id);
                    if (category.name.toLowerCase() == 'product images') {
                      onChangeTabs(category.id);
                      handleFiltersChange(CATEGORY, 81);
                    } else if (category.name.toLowerCase() == 'your images') {
                      onChangeTabs(category.id);
                      handleFiltersChange(CATEGORY, 80);
                    } else {
                      onChangeTabs(category.id);
                      resetFilters();
                    }
                  }}
                >
                  {category.name}
                </span>
              ))}
            </HeaderItem>
          )}

          {!process.env.REACT_APP_GALLERY_FILTER_LAYOUT_ENABLED === 'true' && (
            <HeaderItem className="filter-container d-flex justify-content-end">
              <FilterButtonContainer>
                <FilterButton
                  type="button"
                  onClick={() => handleFiltersChange(FAVORITE)}
                  variant={filter?.favorite ? '' : 'outline'}
                  style={{
                    fontWeight: 500,
                    fontSize: 18,
                  }}
                >
                  Favorite
                </FilterButton>
                {staticFiltersList.map((item, index) => (
                  <FilterButton
                    key={index}
                    type="button"
                    onClick={() => handleFiltersChange(STATICTAGS, item.id)}
                    variant={
                      filter?.staticTags?.includes(item.id) ? '' : 'outline'
                    }
                    style={{
                      fontWeight: 500,
                      fontSize: 18,
                    }}
                  >
                    {item.label}
                  </FilterButton>
                ))}
                <FilterButton
                  type="button"
                  onClick={() =>
                    handleFiltersChange(TYPE, filter.type ? null : 'gif')
                  }
                  variant={filter?.type ? '' : 'outline'}
                  style={{
                    fontWeight: 500,
                    fontSize: 18,
                  }}
                >
                  GIF
                </FilterButton>
              </FilterButtonContainer>
            </HeaderItem>
          )}

          <HeaderItem className="gap-2">
            {/* {(accessingVia === 'editTemplate' ||
              ACCESSEDVIAOMAGEGALLERY ||
              ACCESSEDVIAWEBSITEGALLERY) && ( */}
            <div className="ms-auto">
              <StyledSearchInput
                padding="8px 16px"
                stroke={theme.dark70}
                value={search}
                size="product"
                searchIconClassName="search-icon dark40"
                placeHolder="Search for Image"
                $phFontSize="16px"
                onChange={(e) => setSearch(e.target.value)}
                onReset={() => setSearch('')}
                $phColor={'bodyMedium'}
                $iconColor="dark40"
                svgSize={'24px'}
              />
            </div>
            {process.env.REACT_APP_GALLERY_FILTER_LAYOUT_ENABLED === 'true' && (
              <div>
                <StyledSpan
                  style={{ position: 'relative' }}
                  onClick={() => {
                    setSelectedImages([]);
                    setShowQuickFilters(!showQuickFilters);
                  }}
                  className="d-flex justify-content-center align-items-center"
                >
                  <StyledText
                    color="bodyMedium"
                    $fontSize="16px"
                    $fontWeight="400"
                    style={{
                      whiteSpace: 'nowrap',
                      marginBottom: '0',
                      marginTop: '0',
                    }}
                  >
                    <span className="d-flex flex-row">
                      <span>Quick Filters</span>
                    </span>
                  </StyledText>
                  <div
                    className="mx-1"
                    style={{
                      transform: `rotate(${
                        !showQuickFilters ? '0' : '180'
                      }deg)`,
                    }}
                  >
                    <BottomArrow width={20} height={20} />
                  </div>
                </StyledSpan>
              </div>
            )}
            <div className="ms-auto">
              <FilterButtonContainer>
                <TagFilterHeader
                  tagsList={tagList}
                  tags={imageTags}
                  selectedTags={selectedTags}
                  setSelectedTags={setSelectedTags}
                  setTags={(val) => handleFiltersChange(IMAGETAGS, val)}
                  selection={filter?.imageTags}
                  filterShow={filterShow}
                  setFilterShow={setFilterShow}
                  setShowOccasionTags={setShowOccasionTags}
                  setShowHolidayTags={setShowHolidayTags}
                  setShowOrientationTags={setShowOrientationTags}
                />
              </FilterButtonContainer>
            </div>
          </HeaderItem>
        </HeaderContainer>

        {showQuickFilters &&
          process.env.REACT_APP_GALLERY_FILTER_LAYOUT_ENABLED === 'true' && (
            <HeaderContainer className="px-4 pt-2">
              <HeaderItem className="filter-container d-flex justify-content-end">
                <FilterButtonContainer>
                  <FilterButton
                    type="button"
                    onClick={() => handleFiltersChange(FAVORITE)}
                    variant={filter?.favorite ? '' : 'outline'}
                    style={{
                      fontWeight: 500,
                      fontSize: 18,
                    }}
                  >
                    Favorite
                  </FilterButton>
                  <CustomDropdownStyle
                    show={showOccasionTags}
                    menuClassName="new-menu filter-dropdown"
                    className="custom-drop-down w-auto drop-down border-0 bg-transparent d-none d-md-block"
                    toggleClassName={
                      'table-dropdown ms-0 table-text p-0 border-0 new-font '
                    }
                    menuProps={{
                      align: 'start',
                      style: {
                        maxWidth: 'fit-content',
                        width: '100%',
                        minWidth: 'fit-content',
                        inset: '0 0 0 0 !important',
                      },
                    }}
                    dropDownToggleProps={{
                      as: 'div',
                    }}
                    dropdownToggle={
                      <div style={{ position: 'relative' }}>
                        <FilterButton
                          type="button"
                          onClick={() => {
                            setShowOccasionTags(!showOccasionTags);
                            setShowHolidayTags(false);
                            setShowOrientationTags(false);
                            setFilterShow(false);
                          }}
                          variant={'outline'}
                          style={{
                            fontWeight: 500,
                            fontSize: 18,
                          }}
                          svgStyle={true}
                        >
                          Occasions
                          <span
                            style={{
                              transform: `rotate(${
                                !showOccasionTags ? '0' : '180'
                              }deg)`,
                            }}
                          >
                            <BottomArrow
                              height={20}
                              width={20}
                              fill="currentColor"
                            />
                          </span>
                        </FilterButton>
                        {matchingTagsCount(
                          tagList?.find((t) => t.name === 'Occasion')
                            ?.childTags,
                        ) !== 0 && (
                          <FilterSuperscript
                            quickFilters={true}
                            // active={activeFilterCount}
                            color={'dark30'}
                          >
                            {matchingTagsCount(
                              tagList?.find((t) => t.name === 'Occasion')
                                ?.childTags,
                            )}
                          </FilterSuperscript>
                        )}
                      </div>
                    }
                    size="small"
                    dropdownMenu={
                      <div
                        style={{ width: 'max-content' }}
                        className="d-flex flex-column py-2 px-3"
                      >
                        <div
                          style={{
                            maxHeight: '300px',
                            overflowY: 'auto',
                            width: '200px',
                          }}
                        >
                          {tagList?.find((t) => t.name === 'Occasion')
                            ?.childTags?.length &&
                            tagList
                              ?.find((t) => t.name === 'Occasion')
                              ?.childTags?.map((tag, index) => {
                                return (
                                  <Col
                                    xs={12}
                                    className="d-flex align-items-center gap-2 mt-2"
                                  >
                                    <StyledCheckbox
                                      value={selectedTags?.find(
                                        (t) => t.id === tag?.id,
                                      )}
                                      onChange={(e) => {
                                        handleQuickFilterTagChange(tag, e);
                                      }}
                                    />
                                    <StyledText
                                      color={'bodyMedium'}
                                      $fontSize={'18px'}
                                      $fontWeight={'500'}
                                      style={{
                                        margin: 0,
                                      }}
                                    >
                                      {tag.name}
                                    </StyledText>
                                  </Col>
                                );
                              })}
                        </div>
                        <Col>
                          <hr />
                          <FilterButton
                            style={{ height: '35px', width: '100%' }}
                            onClick={() => {
                              handleFiltersChange(IMAGETAGS, selectedTags);
                              setShowOccasionTags(false);
                              setShowHolidayTags(false);
                              setShowOrientationTags(false);
                            }}
                          >
                            Apply
                          </FilterButton>
                        </Col>
                      </div>
                    }
                  />
                  <CustomDropdownStyle
                    show={showOrientationTags}
                    menuClassName="new-menu filter-dropdown"
                    className="custom-drop-down w-auto drop-down border-0 bg-transparent d-none d-md-block"
                    toggleClassName={
                      'table-dropdown ms-0 table-text p-0 border-0 new-font '
                    }
                    menuProps={{
                      align: 'start',
                      style: {
                        maxWidth: 'fit-content',
                        width: '100%',
                        minWidth: 'fit-content',
                        inset: '0 0 0 0 !important',
                      },
                    }}
                    dropDownToggleProps={{
                      as: 'div',
                    }}
                    dropdownToggle={
                      <div style={{ position: 'relative' }}>
                        <FilterButton
                          type="button"
                          onClick={() => {
                            setShowOrientationTags(!showOrientationTags);
                            setShowOccasionTags(false);
                            setShowHolidayTags(false);
                            setFilterShow(false);
                          }}
                          variant={'outline'}
                          style={{
                            fontWeight: 500,
                            fontSize: 18,
                          }}
                          svgStyle={true}
                        >
                          Orientation
                          <BottomArrow
                            height={20}
                            width={20}
                            // fill={theme2?.primary}
                          />
                        </FilterButton>
                        {matchingTagsCount(
                          tagList?.find((t) => t.name === 'Orientation')
                            ?.childTags,
                        ) !== 0 && (
                          <FilterSuperscript
                            quickFilters={true}
                            // active={activeFilterCount}
                            color={'dark30'}
                          >
                            {matchingTagsCount(
                              tagList?.find((t) => t.name === 'Orientation')
                                ?.childTags,
                            )}
                          </FilterSuperscript>
                        )}
                      </div>
                    }
                    size="small"
                    dropdownMenu={
                      <div
                        style={{ width: 'max-content' }}
                        className="d-flex flex-column py-2 px-3"
                      >
                        <div
                          style={{
                            maxHeight: '300px',
                            overflowY: 'auto',
                          }}
                        >
                          {tagList?.find(
                            (t) => t.name?.toLowerCase() === 'orientation',
                          )?.childTags?.length &&
                            tagList
                              ?.find(
                                (t) => t?.name?.toLowerCase() === 'orientation',
                              )
                              ?.childTags?.map((tag, index) => {
                                return (
                                  <Col
                                    xs={12}
                                    className="d-flex align-items-center gap-2 mt-2"
                                  >
                                    <StyledCheckbox
                                      value={selectedTags?.find(
                                        (t) => t.id === tag?.id,
                                      )}
                                      onChange={(e) => {
                                        handleQuickFilterTagChange(tag, e);
                                      }}
                                    />
                                    <StyledText
                                      color={'bodyMedium'}
                                      $fontSize={'18px'}
                                      $fontWeight={'500'}
                                      style={{
                                        margin: 0,
                                      }}
                                    >
                                      {tag.name}
                                    </StyledText>
                                  </Col>
                                );
                              })}
                        </div>
                        <Col>
                          <hr />
                          <FilterButton
                            style={{ height: '35px', width: '100%' }}
                            onClick={() => {
                              handleFiltersChange(IMAGETAGS, selectedTags);
                              setShowOccasionTags(false);
                              setShowHolidayTags(false);
                              setShowOrientationTags(false);
                            }}
                          >
                            Apply
                          </FilterButton>
                        </Col>
                      </div>
                    }
                  />
                  <CustomDropdownStyle
                    show={showHolidayTags}
                    menuClassName="new-menu filter-dropdown"
                    className="custom-drop-down w-auto drop-down border-0 bg-transparent d-none d-md-block"
                    toggleClassName={
                      'table-dropdown ms-0 table-text p-0 border-0 new-font '
                    }
                    menuProps={{
                      align: 'start',
                      style: {
                        maxWidth: 'fit-content',
                        width: '100%',
                        minWidth: 'fit-content',
                        inset: '0 0 0 0 !important',
                      },
                    }}
                    dropDownToggleProps={{
                      as: 'div',
                    }}
                    dropdownToggle={
                      <div style={{ position: 'relative' }}>
                        <FilterButton
                          type="button"
                          onClick={() => {
                            setShowHolidayTags(!showHolidayTags);
                            setShowOccasionTags(false);
                            setShowOrientationTags(false);
                            setFilterShow(false);
                          }}
                          variant={'outline'}
                          style={{
                            fontWeight: 500,
                            fontSize: 18,
                          }}
                          svgStyle={true}
                        >
                          Holiday
                          <BottomArrow
                            height={20}
                            width={20}
                            fill={theme?.primaryDark}
                          />
                        </FilterButton>
                        {matchingTagsCount(
                          tagList?.find((t) => t.name === 'Holiday')?.childTags,
                        ) !== 0 && (
                          <FilterSuperscript
                            quickFilters={true}
                            // active={activeFilterCount}
                            color={'dark30'}
                          >
                            {matchingTagsCount(
                              tagList?.find((t) => t.name === 'Holiday')
                                ?.childTags,
                            )}
                          </FilterSuperscript>
                        )}
                      </div>
                    }
                    size="small"
                    dropdownMenu={
                      <div
                        style={{ width: 'max-content' }}
                        className="d-flex flex-column py-2 px-3"
                      >
                        <div
                          style={{
                            maxHeight: '300px',
                            overflowY: 'auto',
                          }}
                        >
                          {tagList?.find(
                            (t) => t?.name?.toLowerCase() === 'holiday',
                          )?.childTags?.length &&
                            tagList
                              ?.find(
                                (t) => t?.name?.toLowerCase() === 'holiday',
                              )
                              ?.childTags?.map((tag, index) => {
                                return (
                                  <Col
                                    xs={12}
                                    className="d-flex align-items-center gap-2 mt-2"
                                  >
                                    <StyledCheckbox
                                      value={selectedTags?.find(
                                        (t) => t.id === tag?.id,
                                      )}
                                      onChange={(e) => {
                                        handleQuickFilterTagChange(tag, e);
                                      }}
                                    />
                                    <StyledText
                                      color={'bodyMedium'}
                                      $fontSize={'18px'}
                                      $fontWeight={'500'}
                                      style={{
                                        margin: 0,
                                      }}
                                    >
                                      {tag.name}
                                    </StyledText>
                                  </Col>
                                );
                              })}
                        </div>
                        <Col>
                          <hr />
                          <FilterButton
                            style={{ height: '35px', width: '100%' }}
                            onClick={() => {
                              handleFiltersChange(IMAGETAGS, selectedTags);
                              setShowOccasionTags(false);
                              setShowHolidayTags(false);
                              setShowOrientationTags(false);
                            }}
                          >
                            Apply
                          </FilterButton>
                        </Col>
                      </div>
                    }
                  />
                </FilterButtonContainer>
              </HeaderItem>
            </HeaderContainer>
          )}

        {location?.pathname === '/admin/images-gallery' ? (
          <ImagesGallery
            filter={filter}
            search={searchQuery}
            tags={imageTags}
            selectedTab={selectedTab}
            selectedImage={setSelectedImages}
            selectedImagesArray={selectImages}
            selectMulti={true}
            imageCategories={imageCategories}
            selectedCategory={selectedCategory}
            setSelectedCategory={setSelectedCategory}
            selectImages={selectImages}
            setSelectedImages={setSelectedImages}
          />
        ) : location?.pathname === '/settings/gallery-settings' ? (
          <>
            {getActiveTabId(tabs) === 1 && (
              <ImagesGallery
                isFlorist={'yourImages'}
                isHeading={false}
                filter={filter}
                search={searchQuery}
                comingFrom={comingFrom}
                selectedImage={setSelectedImages}
                selectMulti={true}
                selectedImagesArray={selectImages}
                tags={imageTags}
                selectedTab={selectedTab}
                imageCategories={imageCategories}
                selectedCategory={selectedCategory}
                setSelectedCategory={setSelectedCategory}
                selectImages={selectImages}
                setSelectedImages={setSelectedImages}
              />
            )}

            {getActiveTabId(tabs) === 2 && (
              <ImagesGallery
                isFlorist={'boostFloralImages'}
                isHeading={false}
                filter={filter}
                search={searchQuery}
                comingFrom={comingFrom}
                selectedImage={setSelectedImages}
                selectMulti={true}
                selectedImagesArray={selectImages}
                tags={imageTags}
                selectedTab={selectedTab}
                imageCategories={imageCategories}
                selectedCategory={selectedCategory}
                setSelectedCategory={setSelectedCategory}
                selectImages={selectImages}
                setSelectedImages={setSelectedImages}
              />
            )}

            {getActiveTabId(tabs) === 79 && (
              <ImagesGallery
                isFlorist={'yourImages'}
                isHeading={false}
                filter={filter}
                search={searchQuery}
                comingFrom={comingFrom}
                selectedImage={setSelectedImages}
                selectMulti={true}
                selectedImagesArray={selectImages}
                tags={imageTags}
                selectedTab={selectedTab}
                imageCategories={imageCategories}
                selectedCategory={selectedCategory}
                setSelectedCategory={setSelectedCategory}
                selectImages={selectImages}
                setSelectedImages={setSelectedImages}
              />
            )}
          </>
        ) : (
          <>
            {getActiveTabId(tabs) === 1 && (
              <ImagesGallery
                isFlorist={'yourImages'}
                isHeading={false}
                filter={filter}
                search={searchQuery}
                comingFrom={comingFrom}
                selectedImage={selectImage}
                selectMulti={selectMulti}
                selectedImagesArray={selectedImagesArray}
                tags={imageTags}
                selectedTab={selectedTab}
                imageCategories={imageCategories}
                selectedCategory={selectedCategory}
                setSelectedCategory={setSelectedCategory}
                selectImages={selectImages}
                setSelectedImages={setSelectedImages}
              />
            )}

            {getActiveTabId(tabs) === 2 && (
              <ImagesGallery
                isFlorist={'boostFloralImages'}
                isHeading={false}
                filter={filter}
                search={searchQuery}
                comingFrom={comingFrom}
                selectedImage={selectImage}
                selectMulti={selectMulti}
                selectedImagesArray={selectedImagesArray}
                tags={imageTags}
                selectedTab={selectedTab}
                imageCategories={imageCategories}
                selectedCategory={selectedCategory}
                setSelectedCategory={setSelectedCategory}
                selectImages={selectImages}
                setSelectedImages={setSelectedImages}
              />
            )}

            {getActiveTabId(tabs) === 79 && (
              <ImagesGallery
                isFlorist={'yourImages'}
                isHeading={false}
                filter={filter}
                search={searchQuery}
                comingFrom={comingFrom}
                selectedImage={selectImage}
                selectMulti={selectMulti}
                selectedImagesArray={selectedImagesArray}
                tags={imageTags}
                selectedTab={selectedTab}
                imageCategories={imageCategories}
                selectedCategory={selectedCategory}
                setSelectedCategory={setSelectedCategory}
                selectImages={selectImages}
                setSelectedImages={setSelectedImages}
              />
            )}
          </>
        )}
      </Container>
    </RootContainer>
  );
};

const TagFilterHeader = ({
  tagsList,
  tags,
  selectedTags,
  setSelectedTags,
  setTags,
  selection,
  filterShow,
  setFilterShow,
  setShowOccasionTags,
  setShowHolidayTags,
  setShowOrientationTags,
}) => {
  const [selectedTab, setSelectedTab] = useState(0);

  const handleChange = (item) => {
    if (selectedTags?.some((_item) => _item.id === item.id)) {
      const payload = selectedTags?.filter((_item) => _item.id !== item.id);
      setSelectedTags(payload);
    } else {
      const payload = [...selectedTags, item];
      setSelectedTags(payload);
    }
  };

  const handleApply = () => {
    setTags(selectedTags);
  };

  const handleClearAll = () => {
    setTags([]);
  };

  useEffect(() => {
    setSelectedTags(selection);
  }, [selection]);

  return (
    <CustomDropdown
      show={filterShow}
      menuProps={{
        align: 'right',
        style: {
          width: 'max-content',
        },
      }}
      autoclose={'inside'}
      toggleClassName={
        'table-dropdown ms-0 table-text new-font menu-toggle-unstyled position-relative'
      }
      className="custom-drop-down table-dropdown-custom drop-down new-font"
      dropDownToggleProps={{
        as: 'div',
      }}
      dropdownToggle={
        <>
          <FilterButton
            type="button"
            icon={
              <FilterHamburgerIcon
                size={22}
                superscript
                superscriptValue={selection?.length}
              />
            }
            style={{
              fontWeight: 500,
              fontSize: 18,
              height: '45px',
            }}
            variant={'outline'}
            onClick={() => {
              setShowOccasionTags(false);
              setShowHolidayTags(false);
              setShowOrientationTags(false);
              setFilterShow(!filterShow);
              
            }}
          />
          {selection?.length ? (
            <FilterSuperscript active={selection?.length}>
              {selection.length}
            </FilterSuperscript>
          ) : (
            <></>
          )}
        </>
      }
      dropdownMenu={
        <Container fluid={'lg'} className="border-radius-2">
          <Row className="border-bottom border-grey-30">
            <Col className="px-3 d-flex justify-content-between align-items-center">
              <StyledText
                color="bodyMedium"
                $fontSize="18px"
                $fontWeight="600"
                style={{
                  whiteSpace: 'nowrap',
                  alignSelf: 'baseline',
                  margin: '10px 0',
                }}
              >
                Filter
              </StyledText>
              <Dropdown.Item
                onClick={() => setFilterShow(false)}
                as={'div'}
                bsPrefix="none"
              >
                <NewCloseIcon size={24} style={{ cursor: 'pointer' }} />
              </Dropdown.Item>
            </Col>
          </Row>

          <Row className="max-vh-70 overflow-auto">
            <StyledSidebar className="col-auto px-1 border-end border-grey-300">
              {tagsList
                ?.sort((a, b) => {
                  const valueA = FilterTabOrderList.indexOf(a.name);
                  const valueB = FilterTabOrderList.indexOf(b.name);
                  return valueA - valueB;
                })
                ?.map((item, index) => {
                  const count = selectedTags.filter((_item) =>
                    item.childTags.some((tag) => _item.id === tag.id),
                  )?.length;
                  return (
                    <CustomTab
                      key={index}
                      onClick={() => setSelectedTab(index)}
                      active={selectedTab === index}
                      className="d-flex justify-content-between align-items-center"
                    >
                      <p>{item.name}</p>
                      {count ? (
                        <div className="count d-flex justify-content-center align-items-center">
                          <p>{count}</p>
                        </div>
                      ) : (
                        <></>
                      )}
                    </CustomTab>
                  );
                })}
            </StyledSidebar>
            <Col
              style={{ width: '600px' }}
              className="d-flex flex-column mx-4 my-2"
            >
              <div style={{ flex: 1 }}>
                <StyledText
                  color="bodyMedium"
                  $fontSize="16px"
                  $fontWeight="600"
                  style={{
                    whiteSpace: 'nowrap',
                    alignSelf: 'baseline',
                    marginTop: 10,
                  }}
                >
                  Select Tags
                </StyledText>
                <div>
                  {tagsList?.[selectedTab]?.childTags?.length > 0 && (
                    <div className="d-flex align-items-center gap-3">
                      <StyledTagContainer>
                        {tagsList?.[selectedTab]?.childTags?.map(
                          (tag, index) => {
                            return (
                              <StyledTag
                                active={selectedTags?.some(
                                  (item) => item.id === tag.id,
                                )}
                                key={index}
                                className="singletag gap-3 mt-3"
                                onClick={() => handleChange(tag)}
                              >
                                <p>{tag.name}</p>
                                {selectedTags?.some(
                                  (item) => item.id === tag.id,
                                ) && (
                                  <NewCloseIcon
                                    className={
                                      'align-self-center cursor-pointer'
                                    }
                                  />
                                )}
                              </StyledTag>
                            );
                          },
                        )}
                      </StyledTagContainer>
                    </div>
                  )}
                </div>
              </div>
            </Col>
          </Row>

          <Row>
            <Col className="py-2 px-3 border-top border-grey-300">
              <ButtonToolbar className="justify-content-between">
                <ButtonGroup>
                  <Dropdown.Item as={'div'} bsPrefix="none">
                    <FilterButton textButton onClick={handleClearAll}>
                      Reset
                    </FilterButton>
                  </Dropdown.Item>
                </ButtonGroup>
                <ButtonGroup className="gap-2">
                  <Dropdown.Item as={'div'} bsPrefix="none">
                    <FilterButton
                      onClick={() => setFilterShow(false)}
                      variant={'outline'}
                    >
                      Cancel
                    </FilterButton>
                  </Dropdown.Item>
                  <Dropdown.Item as={'div'} bsPrefix="none">
                    <FilterButton
                      onClick={() => {
                        handleApply(this);
                        setFilterShow(false);
                      }}
                    >
                      Apply
                    </FilterButton>
                  </Dropdown.Item>
                </ButtonGroup>
              </ButtonToolbar>
            </Col>
          </Row>
        </Container>
      }
    />
  );
};

const HeaderContainer = styled.div`
  background-color: ${({ theme }) => theme.white};
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  padding: 0 10px 0 0;

  &.static-filters {
    padding: 20px 10px;
    overflow: initial;
  }

  &.selected-tags {
    padding: 0px 20px;
  }
`;

const HeaderItem = styled(ActivityTabs)`
  overflow-x: initial;
  &.filter-container {
    flex-grow: 1;
    max-height: 45px;
  }
  > span {
    border: none;
    border-bottom: 3px solid transparent;
    background-color: ${({ theme }) => theme.gray10};
    padding : 15px 20px !important;

    &:not(:first-child) {
      border: none;
      border-left: 1px solid ${({ theme }) => theme.dark70};
    }

    &.active {
      border: none;
      &:not(:first-child) {
        border-left: 1px solid ${({ theme }) => theme.dark70};
      }
      background-color: ${({ theme }) => theme.white};
      box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
      border-bottom: 3px solid ${({ theme }) => theme.primary};
    }
  }
`;

const FilterButtonContainer = styled.div`
  display: flex;
  gap: 10px;
  white-space: nowrap;
`;

const CustomTab = styled.div`
  background-color: ${({ theme, active }) =>
    active ? theme.primary : 'transparent'};
  color: ${({ theme, active }) => (active ? theme.white : theme.bodyMedium)};
  padding: 10px 20px 10px 10px;
  margin: 5px;
  border-radius: 5px;
  cursor: pointer;
  white-space: nowrap;
  font-size: 18px;
  font-weight: 500;
  width: 180px;

  .count {
    background-color: ${({ theme, active }) =>
      active ? theme.white : theme.primary};
    height: 22px;
    width: 22px;
    border-radius: 4px;
    color: ${({ theme, active }) => (active ? theme.primary : theme.white)};
    font-family: Instrument Sans;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
  }

  &:hover {
    background-color: ${({ theme }) => theme.primary};
    color: ${({ theme }) => theme.white};

    .count {
      background-color: ${({ theme }) => theme.white};
      color: ${({ theme }) => theme.primary};
    }
  }

  p {
    margin: 0;
  }
`;

const StyledSidebar = styled(Col)`
  background: ${({ theme }) => theme.primaryLight2};
`;

const StyledTagContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 5px 0;
  gap: 10px;
`;

const StyledTag = styled.span`
  padding: 4px 12px 4px 12px;
  color: ${({ theme, active }) => (active ? theme.white : theme.bodyMedium)};
  font-family: ${(theme) => theme.fontFamily};
  border: 1px solid ${({ theme }) => theme.dark40};
  background-color: ${({ theme, active }) =>
    active ? theme.badgeText : theme.white};
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;

  p {
    margin: 0;
  }
`;

const FilterSuperscript = styled.p`
  color: #ffffff;
  background: ${({ theme }) => theme?.primary};
  position: absolute;
  top: -12px;
  font-size: 11px;
  right: -5px;
  height: 25px;
  width: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
`;

const FilterButton = styled(StyledButton)`
  ${({ textButton }) =>
    textButton &&
    `
    padding: 10px 20px;
  `}
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 160%;
  height: 45px;
`;

export default Gallery;
